<template>
  <div class="layout-with-centered-max-width-child">
    <div v-if="lucidDataLoading">
      <Loading/>
    </div>
    <div v-else>
      <div class="text each-row">
        <span>Please select a Country and Language</span>
      </div>
      <div class="dropdown-container">
        <Dropdown :selection=languageCountry>
          <div class="option" v-for="languageCountry in languageCountryNames"
               @click="setLanguageCountry(languageCountry)">
            <span class="options-text">{{ languageCountry }}</span>
          </div>
        </Dropdown>
      </div>
      <div class="each-row">
        <StudyNavigation></StudyNavigation>
      </div>
    </div>
  </div>
</template>

<script>
import StudyNavigation from "../views/StudyNavigation"
import http from "../../services/axios"
import {
  GET_BACKEND_URL,
  GET_HTTP_CONFIG,
  GET_NEXT_STUDY_STEP_ROUTE,
  LOAD_SURVEY_QUALIFICATIONS,
  SET_SURVEY_SELECTED_QUALIFICATIONS,
  STUDY_SOURCE_SELECTION_ACADEMIC
} from "../../services/constants"
import Dropdown from "../general/Dropdown"
import {mapGetters} from "vuex"

export default {
  name: "SurveyQualificationLanguage",
  components: {Dropdown, StudyNavigation},
  created() {
    if (this.$route.query.update) {
      this.lucidDataLoading = true
      this.loadPreviousData()
    } else if (this.isStudyAcademic) {
      this.lucidDataLoading = true
      this.setCountryForAcademicStudy()
    } else {
      http.get(this.$store.getters[GET_BACKEND_URL](`lucid/data/countries`)).then(response => {
        this.languagesAndCountries = response.data
      })
    }
  },

  data() {
    return {
      languageCountry: 'United States (English)',
      languagesAndCountries: [],
      languageCountryId: 9,
      lucidDataLoading: false
    }
  },

  computed: {
    ...mapGetters([
      GET_NEXT_STUDY_STEP_ROUTE,
    ]),
    languageCountryNames() {
      return this.languagesAndCountries.map(languageCountry => {
        return languageCountry['name']
      })
    },
    isStudyAcademic() {
      return this.$store.state.dataModule.inProgressStudy.sourcingMethod === STUDY_SOURCE_SELECTION_ACADEMIC
    }
  },

  methods: {
    setLanguageCountry(selection) {
      this.languageCountry = selection
      this.languageCountryId = this.getLanguageCountryId(selection)
    },
    getLanguageCountryId(selection) {
      for (let languageCountry of this.languagesAndCountries) {
        if (languageCountry['name'] === selection) {
          return languageCountry['id']
        }
      }
    },
    handleSubmit() {
      this.$store.commit(SET_SURVEY_SELECTED_QUALIFICATIONS, {"countryLanguageID": this.languageCountryId})
      this.$store.dispatch(LOAD_SURVEY_QUALIFICATIONS, this.languageCountryId).then(() => {
        this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE])
      })
    },
    setCountryForAcademicStudy() {
      this.languageCountryId = 9
      this.handleSubmit()
    },
    loadPreviousData() {
      let studyId = this.$store.state.dataModule.inProgressStudy.meta.id
      http.get(this.$store.getters[GET_BACKEND_URL](`studies/${studyId}/lucid`), this.$store.getters[GET_HTTP_CONFIG])
        .then(response => {
          this.languageCountryId = response.data.countryLanguageID
          this.handleSubmit()
        })
        .catch(e => {
          console.log("error")
          this.lucidDataLoading = false
        })
    }
  },


}
</script>

<style scoped>

.text {
  text-align: center;
}

span {
  font-size: 1.17em;
}

.dropdown-container {
  padding: 5% 10%;
}

.each-row {
  padding: 5% 0;
}

.option {
  padding: 5px 20px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.options-text {
  font-size: 16px;
}

</style>
